import { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import classNames from "classnames";

import withFormStore from "../Form/withFormStore";
import withAlert from "../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";
import { withPasswordForm } from "./withPasswordForm";
import Modal from "../Modals/Modal";
import PasswordField from "../Form/Field/PasswordField";
import Button from "../Buttons/Button";
import getQueryStringParamByName from "../../helpers/getQueryStringParamByName";
import { intlMessages as formPageIntlMessages } from "../ParticipativeModule/FormPage";

import { editPassword } from "../../mutations/EditPasswordMutation";

class PasswordEditForm extends Component {
  constructor(props) {
    super(props);
    this.onSendResponse = this.onSendResponse.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      resetPasswordToken: getQueryStringParamByName("reset_password_token")
    };
  }

  get labels() {
    const { formatMessage } = this.props.intl;

    return {
      title: formatMessage(intlMessages.title),
      description: formatMessage(intlMessages.description),
      requiredFieldsHint: formatMessage(formPageIntlMessages.requiredFieldsHint),
      password: formatMessage(intlMessages.password),
      passwordConfirmation: formatMessage(intlMessages.passwordConfirmation),
      submit: formatMessage(intlMessages.submit),
      successMessage: formatMessage(intlMessages.successMessage)
    };
  }

  get isSubmitting() {
    return this.state.status === "submitting";
  }

  get formClassName() {
    return classNames({
      "authentication-fieldset": true,
      "authentication-sign-in": true,
      box: true,
      "margin-bottom-xs": true,
      "padding-x-lg": true,
      "padding-y-md": true,
      loading: this.isSubmitting
    });
  }

  get breadcrumbs() {
    return [];
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    this.submitForm();
  }

  submitForm() {
    // Do not submit form if it is already submitting
    if (this.state.status === "submitting") {
      return;
    }

    this.setState({ alertMessage: null });

    if (this.props.validateForm()) {
      this.setState({ status: "submitting" });

      editPassword(
        this.props.formState,
        this.state.resetPasswordToken,
        this.onSendResponse
      );
    } else {
      this.setState({ formValue: this.state.formValue });
    }
  }

  onSendResponse(response) {
    this.setState({ status: "responseReceived" });

    if (response.editPassword.success) {
      this.props.showAlert({
        message: this.labels.successMessage,
        type: ALERT_TYPE_SUCCESS,
        onClick: this.props.onAlertMessageClicked
      });

      // Redirect to home page and reload since the user has been automatically
      // signed in on password reset.
      setTimeout(() => (window.location.href = "/"), 3000);
    } else {
      this.props.showAlert({
        message: response.editPassword.notice,
        type: ALERT_TYPE_ERROR,
        onClick: this.props.onAlertMessageClicked
      });
    }
  }

  render() {
    return (
      <Modal
        isOpen={true}
        shouldCloseOnOverlayClick={false}
        breadcrumbs={this.breadcrumbs}
        title={this.labels.title}
        className="modal-sm"
      >
        <form className={this.formClassName} onSubmit={this.onSubmit}>
          <p className="help-block">{this.labels.description}</p>

          <p
            className="form-hint-required-fields margin-bottom-sm text-small"
            dangerouslySetInnerHTML={{ __html: this.labels.requiredFieldsHint }}
          />
          <PasswordField
            fieldName="password"
            label={this.labels.password}
            required
            autoComplete="new-password"
          />

          <PasswordField
            fieldName="passwordConfirmation"
            label={this.labels.passwordConfirmation}
            required
            confirmationOf="password"
            autoComplete="new-password"
          />

          <Button
            type="submit"
            className="btn btn-primary btn-block-md box-shadow-lg"
            onClick={this.onSubmit}
            disabled={this.isSubmitting}
            data-loading={this.isSubmitting}
            label={this.labels.submit}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />
        </form>
      </Modal>
    );
  }
}

export default injectIntl(withPasswordForm(withFormStore(withAlert(PasswordEditForm))));

const intlMessages = defineMessages({
  title: {
    id: "authentication.passwordEditForm.title",
    defaultMessage: "Réinitialisation du mot de passe"
  },
  description: {
    id: "authentication.passwordEditForm.description",
    defaultMessage: `
      Renseignez votre nouveau mot de passe dans les champs suivants.
    `
  },
  password: {
    id: "authentication.passwordEditForm.labels.password",
    defaultMessage: "Mot de passe"
  },
  passwordConfirmation: {
    id: "authentication.passwordEditForm.labels.passwordConfirmation",
    defaultMessage: "Confirmation du mot de passe"
  },
  submit: {
    id: "authentication.passwordEditForm.submit",
    defaultMessage: "Mettre à jour mon mot de passe"
  },
  successMessage: {
    id: "authentication.passwordEditForm.successMessage",
    defaultMessage: `
      Votre mot de passe a bien été mis à jour, et vous avez été
      automatiquement connecté à votre compte. Vous allez être redirigé
      vers la page d'accueil dans quelques instants ...
    `
  }
});
